import React from 'react';

import { VersionsIcon } from '@primer/octicons-react';

import BlankSlate from '../../../common/BlankSlate/BlankSlate';
import Icon from '../../../common/icons/Icon';

import { getThemeColor } from '../../../../utils/theme-utils';

const NoVersionsGraphic = () => (
  <Icon
    fill={getThemeColor('brand')}
    icon={VersionsIcon}
    size={64}
  />
)

export const NoVersionsSlate = ({
  mainText = "We couldn't find any versions for this pipeline."
}) => (
  <BlankSlate
    className="p-4"
    mainText={mainText}
    Graphic={NoVersionsGraphic}
  />
)

export default NoVersionsSlate;
